import React from 'react';
import { careReasonText } from '../constants';
import { dateTime, terminationEvidenceMessage } from '../presentation';
import { CareRows } from '../types';
import CareTable from './CareTable';

const TerminationPanel: React.FC<{ rows?: CareRows }> = ({ rows }) => {
    const patientNames = new Map<number, string>();
    rows?.rows.forEach((row) => {
        const name = row.patient_name?.trim();
        if (name) patientNames.set(row.hero_user_id, name);
    });
    const evidenceMessage = rows ? terminationEvidenceMessage(rows.termination_evidence) : null;
    return (
        <CareTable
            collapsible
            title="Ended enrollments in this month"
            columns={['Patient', 'Program', 'Enrollment ended', 'Reason']}
            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            rows={rows?.termination_records.map((record) => [
                patientNames.get(record.hero_user_id) ?? 'Patient name unavailable',
                record.program,
                dateTime(record.terminated_at),
                careReasonText(record.termination_reason)
            ])}
            explanations={[
                'Informational records are excluded from active and billable patient totals.',
                ...(evidenceMessage ? [evidenceMessage] : [])
            ]}
        />
    );
};

export default TerminationPanel;
